import * as yup from 'yup';

yup.addMethod(yup.string, 'descontoIgualValorBase', function (errorMessage) {
    return this.test('test-desconto-igual-valor-base', errorMessage, function (_value) {
        const { path, createError,parent } = this;
        let temErro = false;
        const { valorBase,valorDesconto } = parent;

        const parseValorBase = Number.parseFloat(valorBase);
        const parseValorDesconto = Number.parseFloat(valorDesconto);

        if (parseValorBase === parseValorDesconto){
            temErro = true;
        }

        return (
            !temErro ||
            createError({ path,
                message: errorMessage })
        )   ;
    });
});
yup.addMethod(yup.string, 'valorBaseNaoPodeSerZero', function (errorMessage) {
    return this.test('test-valorBase-nao-pode-ser-zero', errorMessage, function (_value) {
        const { path, createError, parent } = this;
        let temErro = false;
        const { valorBase } = parent;
        const parseValorBase = Number.parseFloat(valorBase);

        if (parseValorBase === 0) {
            temErro = true;
        }

        return (
            !temErro ||
            createError({
                path,
                message: errorMessage
            })
        );
    });
});

export const validacoesFormDesconto = yup.object().shape({
    valorBase: yup.string().required('valor base é um campo obrigatório').valorBaseNaoPodeSerZero('Valor Base nao pode ser igual a zero'),
        
    valorDesconto: yup.string().nullable().descontoIgualValorBase('O valor do desconto não pode ser igual ao valor base')
        .test(
            '',
            'O campo Valor do desconto não pode ter um valor maior que o valor base!',
            function (valorDesconto) {
                const { valorBase } = this.parent;

                if (valorBase === undefined || valorDesconto === undefined) {
                    return true;
                } else {
                    const valorBaseFloat = parseFloat(valorBase.replace(',', '.'));
                    const valorDescontoFloat = parseFloat(valorDesconto.replace(',', '.'));

                    if (valorDescontoFloat < valorBaseFloat) {
                        return true;
                    }else{
                        return false;
                    }
                }
            }
        ),

    dataInicioDesconto: yup.date().nullable()
        .when(
            'valorDesconto',{
                is: valorDesconto => valorDesconto,
                then: yup.date().required('Preencha uma data para início do desconto.'),
                otherwise: yup.date()
            }
        ),
    dataFinalDesconto: yup.date().nullable()
        .min(
            yup.ref('dataInicioDesconto'), 'A data final de desconto deve ser maior que a data inicial do desconto!'

        ).min(new Date(), 'A data final de desconto não pode ser inferior a data atual!')
        .when('dataInicioDesconto', {
            is: true,
            then: yup.date().required('Caso a data de início esteja informada, data final deve ser preenchida!'),
            otherwise: yup.date()
        }),

    formasPagamento: yup.lazy(value =>
        yup.boolean().test(
            'pelo-menos-uma-forma-pagamento',
            'Selecione pelo menos uma forma de pagamento',
            function (value) {
                const { valorDesconto, pagamentoCartao, pagamentoBoleto, pagamentoEscelsa } = this.parent;
    
                if (valorDesconto?.length > 0) {
                    return pagamentoCartao || pagamentoBoleto || pagamentoEscelsa;
                }
    
                return true;
            }
        )
    )

});
